module.exports = __webpack_public_path__ + "img/imagen_parrafo_dos.6fa9948d.jpg";